<template lang="pug">
 md-drawer.md-right(:md-active.sync="show")
    md-card-header
        md-card-header-text
          .md-title(style="color: #012C58") {{$t('stablecard.schedule')}}
        md-button.md-icon-button(@click="$emit('update:show', false)")
          md-icon close
    md-card-content
        .md-layout.md-size-100
            .md-layout-item.md-size-15.md-alignment-top-left
                md-button.md-icon-button.md-raised.md-primary(@click="previous")
                    md-icon chevron_left
            .md-layout-item.md-size-70.md-alignment-top-center(style="text-align:center")
                span(style="color: #012C58") {{item.name}}
            .md-layout-item.md-size-15.md-alignment-top-right
                md-button.md-icon-button.md-raised.md-primary(@click="next")
                    md-icon chevron_right
        md-field(:class="{'md-invalid': errors.has('morning')}" )
            md-icon(md-src="/static/img/morning.svg")
            label   {{$t('stablecard.morning')}}
            md-input(v-model.number="morning" type="number" data-vv-name="morning" v-validate="'required'" step="0.001"  style="text-align:right;margin-right:8px")
            span(class="md-suffix") {{item.unit}}
            span.md-error(v-show="errors.has('morning')") {{ errors.first('morning') }}
        md-field(:class="{'md-invalid': errors.has('noon')}" )
            md-icon(md-src="/static/img/noon.svg")
            label   {{$t('stablecard.noon')}}
            md-input(v-model.number="noon" type="number" step="0.001" data-vv-name="noon" v-validate="'required'"  style="text-align:right;margin-right:8px")
            span(class="md-suffix") {{item.unit}}
            span.md-error(v-show="errors.has('noon')") {{ errors.first('noon') }}
        md-field(:class="{'md-invalid': errors.has('evening')}" )
            md-icon(md-src="/static/img/half-moon.svg")
            label   {{$t('stablecard.evening')}}
            md-input(v-model.number="evening" type="number" step="0.001" data-vv-name="evening" v-validate="'required'" style="text-align:right;margin-right:8px")
            span(class="md-suffix") {{item.unit}}
            span.md-error(v-show="errors.has('evening')") {{ errors.first('evening') }}
        md-field(:class="{'md-invalid': errors.has('total')}" style="width: 70%;margin-left: 30%;")
            label {{$t('stablecard.prescription')}} {{item.hoeveelheid}} {{item.unit}}
            span(class="md-prefix") {{$t('stablecard.total')}}
            md-input(readonly v-model.number="item.total" type="number" step="0.01" style="text-align:right;margin-right:8px"  data-vv-name="total" v-validate="{ confirmed: 'cf_total' }" data-vv-validate-on="input")
            span(class="md-suffix") kg
            span.md-error(v-show="errors.has('total')") {{ errors.first('total') }}
        md-field(style="display:none")
          span(class="md-prefix") {{$t('stablecard.ration')}}
          md-input(readonly name="cf_total" ref="cf_total" v-model="item.hoeveelheid")
    md-card-actions
        span(style="flex:1;")
        md-button.md-flat.md-accent(@click="reset" style="color: #012C58;") {{$t('stablecard.reset')}}
        md-button.md-raised.md-primary(@click="save" style="color: #012C58;") {{$t('label.save')}}
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
  name: 'StablecardSidenav',
  props: ['show', 'mpd', 'feed'],
  data: () => {
    return {
      index: 0,
      feeding: []
    }
  },
  watch: {
    feed () {
      this.feeding = this.feed
    }
  },
  computed: {
    ...mapGetters([
      'feedingSchedule'
    ]),
    item () {
      return (this.feeding || [])[this.index] || {}
    },
    morning: {
      set (value) {
        this.item.morning = value
        this.updateTotal()
      },
      get () {
        return this.item.morning
      }
    },
    noon: {
      set (value) {
        this.item.noon = value
        this.updateTotal()
      },
      get () {
        return this.item.noon
      }
    },
    evening: {
      set (value) {
        this.item.evening = value
        this.updateTotal()
      },
      get () {
        return this.item.evening
      }
    }
  },
  methods: {
    updateTotal () {
      var total = Math.round((Math.round((this.item.morning + this.item.noon + this.item.evening) * 1000) / 1000) * 100) / 100
      Vue.set(this.item, 'total', total)
    },
    validateTotal () {
      this.$validator.errors.clear()
      this.$validator.validate('total')
    },
    reset () {
      var orig = this.feedingSchedule(this.mpd)[this.index]
      Vue.set(this.item, 'morning', orig.morning)
      Vue.set(this.item, 'noon', orig.noon)
      Vue.set(this.item, 'evening', orig.evening)
      Vue.set(this.item, 'total', orig.total)
    },
    next () {
      if (this.index < this.feeding.length - 1) {
        this.index++
      }
    },
    previous () {
      if (this.index > 0) {
        this.index--
      }
    },
    save () {
      this.$emit('update:feed', this.feeding)
      this.$emit('update:show', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StablecardSidenav.vue